import { FC, memo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { DataSourceItem, Table as TableUI } from 'ui/components'
import { EmailHistoryReportItem } from '~bank-reports/types/EmailHistoryReport'

import { useEmailHistoryReportContext } from '../../context/EmailHistoryReportContext'
import { columns } from './columns'

export const Table: FC = memo(() => {
  const { data, state, navigate, isPending } = useEmailHistoryReportContext()

  const mappedItems: DataSourceItem<EmailHistoryReportItem>[] =
    data?.items?.map((el) => ({
      item: el
    })) || []

  return (
    <TableUI
      dataQa={TableDataQa.BP_REPORTS_EMAIL_HISTORY_REPORT}
      columns={columns()}
      loading={isPending}
      dataSource={mappedItems}
      pagination={{
        page: state.page,
        size: state.size,
        total: data?.total,
        onChange: (page, pageSize) => {
          navigate({ page, size: pageSize })
        }
      }}
    />
  )
})
